import { create } from "zustand";
import { GuestAccessLink } from "./GuestAccessLink";

interface LinksState {
    loaded: boolean;
    enabled: boolean;
    guestLinks: GuestAccessLink[];
    setEnabled: (enabled: boolean) => void;
    setGuestLinks: (links: GuestAccessLink[]) => void;
    initData: (enabled: boolean, links: GuestAccessLink[]) => void;
}

/**
 * guest links store.
 *
 * guest links can be access from 3 different places on the page, with no
 * consistent mount.
 */
export const useGuestLinksStore = create<LinksState>()((set, get) => ({
    loaded: false,
    enabled: false,
    guestLinks: [],

    initData: (enabled: boolean, links: GuestAccessLink[]) => {
        const { loaded } = get();
        if (!loaded) {
            set((state) => ({ enabled: enabled, guestLinks: links, loaded: true }));
        }
    },
    setEnabled: (enabled: boolean) => set((state) => ({ ...state, enabled: enabled })),
    setGuestLinks: (links: GuestAccessLink[]) => set((state) => ({ ...state, guestLinks: links })),
}));
